import { FormFieldTypes } from "../../../data/formFieldType";

export const CriteriaApprovalData = {
  name: "CriteriaApprovalData",
  initialState: {
    searchByCriteriaName: "",
    channel: null,
    statusId: null,
  },
  formFields: [
    {
      id: "searchByCriteriaName",
      lable: "Search by Criteria Name",
      Field_Name: "Search by Criteria Name",
      fieldType: FormFieldTypes.INPUT,
      dataField: "searchByCriteriaName",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      style: {
        containerCss: "col-lg-12 mb-3 pr-0",
      },
    },
    {
      id: "channel",
      lable: "Channel",
      Field_Name: "Channel",
      fieldType: FormFieldTypes.SELECT,
      dataField: "channel",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      style: {
        containerCss: "col-lg-4",
      },
    },
    {
      id: "statusId",
      lable: "Status",
      Field_Name: "Status",
      fieldType: FormFieldTypes.SELECT,
      dataField: "statusId",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      style: {
        containerCss: "col-lg-4",
      },
    },
  ],
  formSetting: {
    isViewOnly: false,
  },
};
